/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-arrows': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.625 12.875l-2.25 2.25V2.5h-1.25v12.625l-2.25-2.25-.875.875 3.75 3.75 3.75-3.75-.875-.875zM6.25 2.5L2.5 6.25l.875.875 2.25-2.25V17.5h1.25V4.875l2.25 2.25L10 6.25 6.25 2.5z"/>'
  }
})
